// TABLE HEADERS

import { Page } from "../translations/types";
import { TABLE_HEADERS_TRANSLATIONS } from "../translations/util";

interface ITableHeaders {
  key: string;
  header: string;
  isSortable: boolean;
}
export const ORGANIZATION_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "ORG-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG]["ORG-ID"],
    isSortable: true,
  },
  {
    key: "ORG-NAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG]["ORG-NAME"],
    isSortable: true,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG].action,
    isSortable: false,
  },
];

export const P25_GROUP_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "TARGET-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_GROUP]["TARGET-ID"],
    isSortable: false,
  },
  {
    key: "PERIOD",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_GROUP].PERIOD,
    isSortable: false,
  },
  {
    key: "RFSS",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_GROUP].RFSS,
    isSortable: false,
  },
  {
    key: "MONITOR",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_GROUP].MONITOR,
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_GROUP].action,
    isSortable: false,
  },
];

export const P25_AFFILIATIONS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "TARGET-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_AFFILIATIONS]["TARGET-ID"],
    isSortable: false,
  },
  {
    key: "PERIOD",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_AFFILIATIONS].PERIOD,
    isSortable: false,
  },
  {
    key: "RFSS",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_AFFILIATIONS].RFSS,
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_AFFILIATIONS].action,
    isSortable: false,
  },
];

export const ORGANIZATION_MAPPING_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "ORG-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG_MAPPING]["ORG-ID"],
    isSortable: true,
  },
  {
    key: "IWF-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG_MAPPING]["IWF-ID"],
    isSortable: true,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG_MAPPING].action,
    isSortable: false,
  },
];
export const ORGANIZATION_TRANSLATION_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG_TRANSLATION].ID,
    isSortable: false,
  },
  {
    key: "EFI",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG_TRANSLATION].EFI,
    isSortable: false,
  },
  {
    key: "EFO",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG_TRANSLATION].EFO,
    isSortable: false,
  },
  {
    key: "FROM",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG_TRANSLATION].FROM,
    isSortable: false,
  },
  {
    key: "TO",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG_TRANSLATION].TO,
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ORG_TRANSLATION].action,
    isSortable: false,
  },
];
export const LOCATIONS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "IWF-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LOCATION]["IWF-ID"],
    isSortable: true,
  },
  {
    key: "IWF-LOCATION-NAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LOCATION]["IWF-LOCATION-NAME"],
    isSortable: true,
  },
  {
    key: "IWF-DOMAIN-NAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LOCATION]["IWF-DOMAIN-NAME"],
    isSortable: true,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LOCATION].action,
    isSortable: false,
  },
];
export const XSSI_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "CONNECTION-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.XSSI_CONNECTION]["CONNECTION-ID"],
    isSortable: true,
  },
  {
    key: "RADIO-IPV4-ADDR",
    header: TABLE_HEADERS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"],
    isSortable: true,
  },
  {
    key: "RADIO-RFSS-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-RFSS-ID"],
    isSortable: true,
  },
  {
    key: "RADIO-SYSTEM-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-SYSTEM-ID"],
    isSortable: true,
  },
  {
    key: "RADIO-WACN-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-WACN-ID"],
    isSortable: true,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.XSSI_CONNECTION].action,
    isSortable: false,
  },
];
export const OTAR_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "CONNECTION-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.OTAR_CONNECTION]["CONNECTION-ID"],
    isSortable: true,
  },
  {
    key: "KMF-RADIO-SET-IDENTIFIER",
    header:
      TABLE_HEADERS_TRANSLATIONS[Page.OTAR_CONNECTION][
        "KMF-RADIO-SET-IDENTIFIER"
      ],
    isSortable: true,
  },
  {
    key: "KMF-PORT",
    header: TABLE_HEADERS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-PORT"],
    isSortable: false,
  },
  {
    key: "KMF-IPV4-ADDR",
    header: TABLE_HEADERS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-IPV4-ADDR"],
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.OTAR_CONNECTION].action,
    isSortable: false,
  },
];
export const CANNED_MESSAGES_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "MSG-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.CANNED_MESSAGE]["MSG-ID"],
    isSortable: true,
  },
  {
    key: "CANNED-TEXT",
    header: TABLE_HEADERS_TRANSLATIONS[Page.CANNED_MESSAGE]["CANNED-TEXT"],
    isSortable: true,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.CANNED_MESSAGE].action,
    isSortable: false,
  },
];
export const LMR_USERS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "LMR-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LMR_USER]["LMR-ID"],
    isSortable: true,
  },
  {
    key: "LMR-NW-TYPE",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LMR_USER]["LMR-NW-TYPE"],
    isSortable: true,
  },
  {
    key: "MAPPED-MCPTT-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LMR_USER]["MAPPED-MCPTT-ID"],
    isSortable: true,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LMR_USER].action,
    isSortable: false,
  },
];
export const LMR_GROUPS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "TG-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LMR_GROUP]["TG-ID"],
    isSortable: true,
  },
  {
    key: "MAPPED-MCPTT-GID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LMR_GROUP]["MAPPED-MCPTT-GID"],
    isSortable: true,
  },
  {
    key: "LMR-NW-TYPE",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LMR_GROUP]["LMR-NW-TYPE"],
    isSortable: true,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.LMR_GROUP].action,
    isSortable: false,
  },
];
export const MCPTT_USERS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "MCPTT-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.MCPTT_USER]["MCPTT-ID"],
    isSortable: true,
  },
  {
    key: "DISPLAY-NAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.MCPTT_USER]["DISPLAY-NAME"],
    isSortable: true,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.MCPTT_USER].action,
    isSortable: false,
  },
];
export const MCPTT_GROUPS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "MCPTT-GID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.MCPTT_GROUP]["MCPTT-GID"],
    isSortable: true,
  },
  {
    key: "MAPPED-P25-TG-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.MCPTT_GROUP]["MAPPED-P25-TG-ID"],
    isSortable: true,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.MCPTT_GROUP].action,
    isSortable: false,
  },
];
export const DFSI_CONNECTIONS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "CONNECTION-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CONNECTION]["CONNECTION-ID"],
    isSortable: true,
  },
  {
    key: "DFSI-VERSION",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CONNECTION]["DFSI-VERSION"],
    isSortable: false,
  },
  {
    key: "HOST-CONTROL-IPV4-ADDR",
    header:
      TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CONNECTION][
        "HOST-CONTROL-IPV4-ADDR"
      ],
    isSortable: false,
  },
  {
    key: "HOST-VOICE-IPV4-ADDR",
    header:
      TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CONNECTION]["HOST-VOICE-IPV4-ADDR"],
    isSortable: false,
  },
  {
    key: "FIXED-STATION-CONTROL-IPV4-ADDR",
    header:
      TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CONNECTION][
        "FIXED-STATION-CONTROL-IPV4-ADDR"
      ],
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CONNECTION].action,
    isSortable: false,
  },
];
export const DFSI_CHANNELS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "CONNECTION-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CHANNEL]["CONNECTION-ID"],
    isSortable: true,
  },
  {
    key: "CHANNEL-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CHANNEL]["CHANNEL-ID"],
    isSortable: false,
  },
  {
    key: "CHANNEL-MODE",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CHANNEL]["CHANNEL-MODE"],
    isSortable: false,
  },
  {
    key: "OUTBOUND-NETWORK-ACCESS-CODE",
    header:
      TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CHANNEL][
        "OUTBOUND-NETWORK-ACCESS-CODE"
      ],
    isSortable: false,
  },
  {
    key: "INBOUND-NETWORK-ACCESS-CODE",
    header:
      TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CHANNEL][
        "INBOUND-NETWORK-ACCESS-CODE"
      ],
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_CHANNEL].action,
    isSortable: false,
  },
];
export const DFSI_GROUPS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "DFSI-LOGICAL-GID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_GROUP]["DFSI-LOGICAL-GID"],
    isSortable: true,
  },
  {
    key: "DFSI-GROUP-NAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_GROUP]["DFSI-GROUP-NAME"],
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.DFSI_GROUP].action,
    isSortable: false,
  },
];
export const ALARM_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "NOTIFICATION-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ACTIVE_ALARM]["NOTIFICATION-ID"],
    isSortable: false,
  },
  {
    key: "EVENT-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ACTIVE_ALARM]["EVENT-ID"],
    isSortable: false,
  },
  {
    key: "HOSTNAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ACTIVE_ALARM].HOSTNAME,
    isSortable: false,
  },
  {
    key: "CreatedAt",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ACTIVE_ALARM].CreatedAt,
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.ACTIVE_ALARM].action,
    isSortable: false,
  },
];
export const FAULTS_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "EVENT-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FAULTS]["EVENT-ID"],
    isSortable: false,
  },
  {
    key: "HOSTNAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FAULTS].HOSTNAME,
    isSortable: false,
  },
  {
    key: "CreatedAt",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FAULTS].CreatedAt,
    isSortable: false,
  },
  {
    key: "INSTANCE",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FAULTS].INSTANCE,
    isSortable: false,
  },
  {
    key: "VERSION",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FAULTS].VERSION,
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FAULTS].action,
    isSortable: false,
  },
];
export const FIXED_NETWORK_ELEMENT_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "TARGET-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT]["TARGET-ID"],
    isSortable: false,
  },
  {
    key: "PERIOD",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].PERIOD,
    isSortable: false,
  },
  {
    key: "RFSS",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].RFSS,
    isSortable: false,
  },
  {
    key: "MONITOR",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].MONITOR,
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].action,
    isSortable: false,
  },
];
export const INVENTORY_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "EVENT-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INVENTORY]["EVENT-ID"],
    isSortable: false,
  },
  {
    key: "EVENT-NAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INVENTORY]["EVENT-NAME"],
    isSortable: false,
  },
  {
    key: "EVENT-PERCEIVED-SEVERITY",
    header:
      TABLE_HEADERS_TRANSLATIONS[Page.INVENTORY]["EVENT-PERCEIVED-SEVERITY"],
    isSortable: false,
  },
  {
    key: "EVENT-SYMPTOMS",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INVENTORY]["EVENT-SYMPTOMS"],
    isSortable: false,
  },
  {
    key: "SOURCE-COMPONENT",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INVENTORY]["SOURCE-COMPONENT"],
    isSortable: false,
  },
  {
    key: "state",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INVENTORY].state,
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INVENTORY].action,
    isSortable: false,
  },
];
export const INSTANCES_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "ENGINE-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INSTANCE]["ENGINE-ID"],
    isSortable: false,
  },
  {
    key: "HOSTNAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INSTANCE].HOSTNAME,
    isSortable: false,
  },
  {
    key: "INSTANCE",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INSTANCE].INSTANCE,
    isSortable: false,
  },
  {
    key: "STARTED-AT",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INSTANCE]["STARTED-AT"],
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.INSTANCE].action,
    isSortable: false,
  },
];
export const HISTORICAL_ALARM_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "EVENT-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.HISTORICAL_ALARM]["EVENT-ID"],
    isSortable: false,
  },
  {
    key: "HOSTNAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.HISTORICAL_ALARM].HOSTNAME,
    isSortable: false,
  },
  {
    key: "ROW-TYPE",
    header: TABLE_HEADERS_TRANSLATIONS[Page.HISTORICAL_ALARM]["ROW-TYPE"],
    isSortable: false,
  },
  {
    key: "CreatedAt",
    header: TABLE_HEADERS_TRANSLATIONS[Page.HISTORICAL_ALARM].CreatedAt,
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.HISTORICAL_ALARM].action,
    isSortable: false,
  },
];
export const REALTIME_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "GROUP-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.PUBLISH_INFO]["GROUP-ID"],
    isSortable: false,
  },
  {
    key: "USER-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.PUBLISH_INFO]["USER-ID"],
    isSortable: false,
  },
  {
    key: "SECS-TO-EXPIRE",
    header: TABLE_HEADERS_TRANSLATIONS[Page.PUBLISH_INFO]["SECS-TO-EXPIRE"],
    isSortable: false,
  },
];

export const P25_UNIT_TABLE_HEADERS = [
  {
    key: "TARGET-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_UNIT]["TARGET-ID"],
    isSortable: false,
  },
  {
    key: "PERIOD",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_UNIT].PERIOD,
    isSortable: false,
  },
  {
    key: "RFSS",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_UNIT].RFSS,
    isSortable: false,
  },
  {
    key: "MONITOR",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_UNIT].MONITOR,
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.P25_UNIT].action,
    isSortable: false,
  },
];

export const IKI_TABLE_HEADERS: ITableHeaders[] = [
  {
    key: "CONNECTION-ID",
    header: TABLE_HEADERS_TRANSLATIONS[Page.IKI_CONNECTION]["CONNECTION-ID"],
    isSortable: true,
  },
  {
    key: "IKI-NAME",
    header: TABLE_HEADERS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-NAME"],
    isSortable: true,
  },
  {
    key: "IKI-PORT",
    header: TABLE_HEADERS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-PORT"],
    isSortable: false,
  },
  {
    key: "IKI-IPV4-ADDR",
    header: TABLE_HEADERS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-IPV4-ADDR"],
    isSortable: false,
  },
  {
    key: "action",
    header: TABLE_HEADERS_TRANSLATIONS[Page.IKI_CONNECTION].action,
    isSortable: false,
  },
];
